module.exports = __webpack_public_path__ + "static/media/tier-8.6e8c0a69.jpg";